import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const VendedorPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}> Usuarios vendedores</PageTitle>
      <View />
    </>
  );
};

export { VendedorPage };
